import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import BenefitsSection from './components/BenefitsSection';
import SafetySection from './components/SafetySection';
import ArticlePreviewGrid from './components/ArticlePreviewGrid';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <CategoryDropdown />
      <CategoryGrid />
      <AboutSection />
      <BenefitsSection />
      <SafetySection />
      <ArticlePreviewGrid />
      <Footer />
    </main>
  );
}